import React, { useEffect, useState } from 'react'
import CMS from '../../components/cms/CMS'
import CrudUser from './CrudUser'
import PageBanner from '../../components/general/PageBanner'
import { useTranslation } from 'react-i18next'
import CMSTable from '../../components/general/CMSTable'
import { columns } from '../../utilities/columns/userColumns'
import { useDispatch } from 'react-redux'
import { fetchUserGetAll } from '../../redux/slices/userGetAllSlice'
import { useSelector } from 'react-redux'
import { fetchUserDelete } from '../../redux/slices/userDeleteSlice'

const UsersPage = () => {
    const [addUserModal, setAddUserModal] = useState(false)
    const [selectedItem, setSelectedItem] = useState(0)
    const [loading, setLoading] = useState(false);
    const users = useSelector((state) => state.userGetAll.data)
    const dispatch = useDispatch()
    const { t } = useTranslation()

    const getData = async () => {
        setLoading(true);
        await dispatch(fetchUserGetAll())
        setLoading(false);
    }
    const deleteData = async (id) => {
        await dispatch(fetchUserDelete({ id: id }))
        getData()
    }

    useEffect(() => { getData() }, [dispatch])

    return (
        <CMS>
            <PageBanner
                modal={addUserModal}
                setModal={setAddUserModal}
                title={t("users")}
                description={t("users_description")}
                buttonText={t("user_add")}
            />
            <CMSTable
                columns={columns({
                    t: t,
                    setSelectedItem: setSelectedItem,
                    modal: addUserModal,
                    deleteData: deleteData,
                    setModal: setAddUserModal,
                })}
                data={users}
                loading={loading}
            />
            <CrudUser
                addUserModal={addUserModal}
                setAddUserModal={setAddUserModal}
                getData={getData}
                selectedItem={selectedItem}
                setSelectedItem={setSelectedItem}
            />
        </CMS>
    )
}

export default UsersPage
